import { env } from "@/env";
import type { AppRouter } from "@template/api/trpc";
import { createTRPCReact, httpBatchLink } from "@trpc/react-query";

export const trpc = createTRPCReact<AppRouter>();

export function getTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${env.VITE_API_URL}/api/trpc`,
        fetch(url, options) {
          const init: RequestInit = {
            credentials: "include",
          };
          if (options?.method) init.method = options.method;
          if (options?.headers) init.headers = options.headers;
          if (options?.body != null) init.body = options.body;
          if (options?.signal != null) init.signal = options.signal;
          return globalThis.fetch(url, init);
        },
      }),
    ],
  });
}
